import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

//Miscellaneous 
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import { Icon } from "@iconify/react";
//Components 
// import ProfileSideBar from "../ProfileSideBar/ProfileSideBar";
import BankTransfer from "./BankTransfer";
import Crypto from "./Crypto";
import SideBar from "../../components/Sidebar/Sidebar";
import { Modal } from "react-responsive-modal";
//Actions 
import * as actions from "../../store/ducks/withdrawal/actions";
import MobileWithdrawal from "./MobileWithdrawal";

class Withdrawal extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state =
        {
            withdrawalOption: "",
            transactionChannel: [],
            loading: true,
            paymentTypeId: "",
            paymentGatewaySelected: "",
            cryptoChannel: "",
            cryptoType: "",
            channelId: "",
            paymentGateway: [],
            showModal: false,
        }
    }

    componentDidMount() 
    {
        this.props.funcGetDropDown();
    }

    shouldComponentUpdate(nextProps, nextState) {
        // const { t } = this.props;
        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown !== undefined) {
            if (nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === "success") {
               // let withdrawalOption = this.state.withdrawalOption;

               // nextProps.dropDown.data.transaction_channel.forEach((val) => {
               //     withdrawalOption = (withdrawalOption === "" && val.wd_status === 1) ? val.slug : withdrawalOption;
               // });
               // pick the first NON-CRYPTO channel as default
                let withdrawalOption = this.state.withdrawalOption;
                nextProps.dropDown.data.transaction_channel
                .filter(v => v.slug !== "crypto")
                .forEach((val) => {
                    withdrawalOption = (withdrawalOption === "" && val.wd_status === 1) ? val.slug : withdrawalOption;
                });

                let paymentTypeId = "";
                let paymentGatewaySelected = "";
                let cryptoType = "";
                let cryptoChannel = "";
                let channelId = "";

                if(withdrawalOption === "crypto"){
                    nextProps.dropDown.data.payment_gateway.map((val) => {
                        if (val.slug_details === "crypto-vendor" && val.wd_status === 1) {
                            if (paymentTypeId === "") {
                                paymentTypeId = val["id"];
                                paymentGatewaySelected = val["slug"];
                            }
                        }

                        else if (val.transaction_slug === "crypto" && val.wd_status === 1 && val.dp_status === 1) {
                            if (channelId === "") {
                                channelId = val["id"];
                                cryptoType = val['slug_details'];
                                cryptoChannel = val['slug'];
                            }
                        }
                    });
                }

                this.setState({
                    //withdrawalOption: withdrawalOption,
                    //transactionChannel: nextProps.dropDown.data.transaction_channel,
                    withdrawalOption,
                    // remove crypto from the list that renders the option cards
                    transactionChannel: nextProps.dropDown.data.transaction_channel.filter(v => v.slug !== "crypto"),
                    loading: false,
                    paymentTypeId: paymentTypeId,
                    paymentGatewaySelected: paymentGatewaySelected,
                    paymentGateway: nextProps.dropDown.data.payment_gateway,
                    cryptoChannel: cryptoChannel,
                    channelId: channelId,
                    cryptoType: cryptoType,
                });
            }
        }
        return true;
    }

    optionSelectHandler = (e, option, optionId) => 
    {
        e.preventDefault();
        if (option === "crypto") {
            // ignore/force to bank transfer
            this.setState({ withdrawalOption: "bank-transfer" });
            return;
        }
        let paymentTypeId = "";
        let paymentGatewaySelected = "";

        let cryptoType = "";
        let cryptoChannel = "";
        let channelId = "";

        if(option === "crypto"){
            this.state.paymentGateway.map((val) => {
                if (val.slug_details === "crypto-vendor" && val.wd_status === 1) {
                    if (paymentTypeId === "") {
                        paymentTypeId = val["id"];
                        paymentGatewaySelected = val["slug"];
                    }
                }

                else if (val.transaction_slug === "crypto" && val.dp_status === 1 && val.wd_status === 1) {
                    if (channelId === "") {
                        channelId = val["id"];
                        cryptoType = val['slug_details'];
                        cryptoChannel = val['slug'];
                    }
                }
            });
        }

        this.setState({
            withdrawalOption: option,
            paymentTypeId: paymentTypeId,
            paymentGatewaySelected: paymentGatewaySelected,
            cryptoChannel: cryptoChannel,
            channelId: channelId,
            cryptoType: cryptoType,
        });
    }

    redirectHandler = () => {
        this.props.history.push({
            pathname: '/transaction-history',
            state: {
                historyTab: 'withdrawal',
                defaultTab: 1
            }
        });
    };

    toggleModal = () => 
    {
        this.setState({
            showModal: !this.state.showModal,
        });
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    render() {
        const { t } = this.props;
        let transactionChannel = this.state.transactionChannel ? this.state.transactionChannel : [];
        const icons = this.imageImport(require.context("../../assets/images/profile/icons", false, /\.(png|jpe?g|svg)$/));

        return (
            <Auxiliary>
            <Modal open={this.state.showModal} onClose={this.toggleModal} classNames={{ modal: "pd-edit-modal" }} center>
                <div className={!isDesktop ? "modal-content edit" : "edit"}>
                <div className="modal-header">
                    <h4 className="modal-title mb-3">{t('deposit.notice')}</h4>
                </div>
                <div className="modal-body">
                <ol className="px-3">
                  <li className="mb-2">{t('withdrawal.notice-content-1')}<a href="/" onClick={window['liveChatButton']}>{t('withdrawal.notice-content-2')}</a>{t('withdrawal.notice-content-3')}</li>
                  <li className="mb-2">{t('withdrawal.notice-content-4')}</li>
                  <li className="mb-2">{t('withdrawal.notice-content-5')}</li>
                  <li className="mb-2">{t('withdrawal.notice-content-6')}</li>
                </ol>
                    {isDesktop && (
                        <button className="btn btn-gradient-blue w-50 d-block mx-auto mt-4" onClick={this.toggleModal}>
                            {t('global.ok')}
                        </button>
                    )}
                </div>
                {!isDesktop && (
                    <div class="modal-footer" onClick={this.toggleModal}>
                        <button className="btn modal-btn-confirm ">{t('global.ok')}</button>
                    </div>
                )}
                </div>

                {!isDesktop && (
                    <div className="modal-m-close-btn" onClick={this.toggleModal}>
                        <p className="modal-close-btn">{t('global.close')}</p>
                    </div>
                )}
            </Modal>

                {isDesktop ? (
                    <section className="pf-dashboard">
                        <div className="x-container">
                            <SideBar />
                            <div className="row">
                                <div className="col-12">
                                    <div className="pd-card-col d-flex flex-column h-100">
                                    <div className="pd-header mb-3"> 
                                    <h4 className="mb-0">{t("sidebar.withdraw")}</h4>
                                        <button className="btn">
                                                <Icon icon="material-symbols:info" onClick={this.toggleModal} />
                                            </button>
                                            </div>

                                        <div className="pd-content mb-3">
                                            {this.state.loading ? (
                                                <Skeleton count={4} height={50} style={{ marginBottom: "1rem" }} />
                                            ) : (
                                                <div className="d-grid gap-3">
                                                    <div>
                                                        <label className="col-form-label">{t("withdraw.withdraw-options")}:</label>
                                                        <div className="select-bank-opts">
                                                            {transactionChannel.map((val, idx) => {
                                                                if (val.wd_status === 1) {
                                                                    return (
                                                                        <div
                                                                            className="form-check form-check-inline"
                                                                            onClick={(event) => this.optionSelectHandler(event, val.slug, val.id)}
                                                                            key={idx}
                                                                        >
                                                                            <input
                                                                                className="btn-check"
                                                                                type="radio"
                                                                                name="withdrawalOption"
                                                                                id={`withdrawal${val.slug}`}
                                                                                value={val.slug}
                                                                                onChange={() => { }}
                                                                                checked={this.state.withdrawalOption === val.slug ? true : false}
                                                                            />
                                                                            <label className="btn square-label form-check-label" htmlFor={`withdrawal${val.slug}`}>
                                                                                <img src={icons[`${val.slug}.svg`]} alt={val.slug} />
                                                                                <p>{t(`transaction-channel.${val.slug}`)}</p>
                                                                            </label>
                                                                        </div>
                                                                    );
                                                                }
                                                                else {
                                                                    return null;
                                                                }
                                                            })}
                                                        </div>
                                                    </div>

                                                    {this.state.withdrawalOption === 'quick-pay' ? (
                                                        <>{t("transaction-channel.quick-pay")} ({t("global.coming-soon")})</>
                                                    ) : this.state.withdrawalOption === 'e-wallet' ? (
                                                        <>{t("transaction-channel.e-wallet")} ({t("global.coming-soon")})</>
                                                    ) : this.state.withdrawalOption === 'crypto' ? (
                                                        <Crypto
                                                            redirectHandler={this.redirectHandler}
                                                            {...this.state}
                                                        />
                                                    ) : this.state.withdrawalOption === 'bank-transfer' ? (
                                                        <BankTransfer
                                                            redirectHandler={this.redirectHandler}
                                                            {...this.state}
                                                        />
                                                    ) : (
                                                        <>{t("validation.invalid-option")}</>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="payment-notices-col">
                                            <h6>{t('withdrawal.important-notice')}</h6>
                                            <ol>
                                                <li>{t('withdrawal.notice-content-1')}<a href="/" onClick={window['liveChatButton']}>{t('withdrawal.notice-content-2')}</a>{t('withdrawal.notice-content-3')}</li>
                                                <li>{t('withdrawal.notice-content-4')}</li>
                                                <li>{t('withdrawal.notice-content-5')}</li>
                                                <li>{t('withdrawal.notice-content-6')}</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section >
                ) : (
                    <MobileWithdrawal
                        optionSelectHandler={this.optionSelectHandler}
                        redirectHandler={this.redirectHandler}
                        toggleModal={this.toggleModal}
                        {...this.state}
                        {...this.props}
                    />
                )}
            </Auxiliary >
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    return {
        dropDown: state.withdrawal.dropDown,
    };
};

//Using the redux calling api methods
const mapDispatchToProps = (dispatch) => {
    return {
        funcGetDropDown: () => dispatch(actions.getDropDown()),
    };
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(Withdrawal));
